export enum OutlookRecipientTypeEnum {
    Required = 0,
    Optional = 1,
    Resources = 2
}